import { render, staticRenderFns } from "./weatherRead.vue?vue&type=template&id=20d88425&lang=pug"
import script from "./weatherRead.vue?vue&type=script&lang=js"
export * from "./weatherRead.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports